// Import react
import React, { useState, useEffect } from "react";

// Import states, contexts, and CSS
import { useActiveUser } from "../../store/activeUserContext";

import { SpinnerGeneric } from "../../utils/general/spinners";
import { Card, Form, Row, Col, Button, Table } from "react-bootstrap";
import { PlusCircle, Pencil, XCircle } from "react-bootstrap-icons";


const CertificationsListComponent = () => {
  // Get user data from context
  const { activeUser } = useActiveUser();

  // Get variables from local storage
  const userId = activeUser._id;
  const token = localStorage.getItem("token");

  const [certificationsList, setCertificationsList] = useState([]);

  useEffect(() => {
    const fetchCertifications = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URL}/api/certifications/users/${activeUser._id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          setCertificationsList(data);
        }
      } catch (error) {
        console.error("Error fetching cutting dies:", error);
      }
    };

    fetchCertifications();

  }, [ ]);

  return (
    <div>
      {/* Utente registrato */}
      <Row>
        <Col xs={12} lg={12}>
          {activeUser ? (
            <>
              <div>Utente registrato: {activeUser._id}</div>
              <div>Nome utente: {activeUser.firstName}</div>
            </>
          ) : (
            <div>Nessun utente registrato.</div>
          )}
        </Col>
      </Row>

      {/* Tabella Materiali */}
      <Row>
        <Col xs={12} lg={12}>
          <Card className="mt-4 mb-5">
            <Card.Header>
              <Card.Title>Certifications Table</Card.Title>
            </Card.Header>
            <Card.Body>
            </Card.Body>
            <hr />
            <Card.Body>
              <Table bordered hover>
                <thead>
                  <tr>
                    <th>Certification Id</th>
                    <th>Certification Name</th>
                    <th>Certification Description</th>
                    <th>Certification Code</th>
                    <th>Action</th>

                  </tr>
                </thead>
                <tbody>
                  {              certificationsList.map((certification, index) => (
                        <tr key={index}>
                          <td>{certification._id}</td>
                          <td>{certification.certificationName}</td>
                          <td>{certification.certificationDesc}</td>
                          <td>{certification.certificationCode}</td>
                          <td>
                            <Button variant="outline-primary" size="sm">
                              <Pencil size={16} />
                            </Button>
                            <Button variant="outline-danger" size="sm">
                              <XCircle size={16} />
                            </Button>
                          </td>
                        </tr>
                    ))
                    }
                </tbody>
              </Table>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CertificationsListComponent;
